import { useTranslation } from "react-i18next";
import FeteCard from "./FeteCard";
import React, { useEffect, useState } from "react";

import ReactDOM from 'react-dom';
import ReactPaginate from 'react-paginate';
import useEventListHook from "hooks/dashboard/useEventList";
import useAppState from "context/useAppState";
import { EVENT_PER_PAGE } from "utils/constant";
import allImgPaths from "assets/images";
import { useNavigate } from "react-router-dom";
import { cloneDeep } from "lodash";
interface FeteListProps {
    events: [],
    total: 0,
    type: any
}

const FeteList = (props: FeteListProps) => {
    const { events, type } = props;
    const {
        setState,
    } = useAppState("eventList");

    const [fetesData, setFetesData] = useState<any>(props.events || [])
    const { resetStateToDefaults: resetChatToDefaults, createNewEvent } = useAppState('chatBox');
    const { newFeteDetails } = useAppState('newFeteChat');
    const navigate = useNavigate();

    const perPage = EVENT_PER_PAGE;
    let totalPages = 0;
    const [currentPage, setCurrentPage] = useState(0);

    if (props?.total > 0) {
        totalPages = Math.ceil(props.total / perPage);
    }

    const { t } = useTranslation();

    useEffect(() => {
        setFetesData(events)
    }, [events])

    const handlePageClick = (data: any) => {
        const selectedPage = data.selected + 1;

        setCurrentPage(selectedPage);

        if (props.type == 'upcoming') {
            setState({
                is_past_events: false,
                upcomingPage: selectedPage
            })
        } else {
            setState({
                is_past_events: true,
                pastPage: selectedPage
            })
        }
    };

    const handleNewFeteClick = async () => {
        resetChatToDefaults();
        const newFete = await createNewEvent({ ...newFeteDetails, is_draft: true });
        const event = newFete?.data
        navigate(`/fete/new/${event?._id}`);
    }


    const afterDelete = (args: any) => {
        const newEvents = cloneDeep(events)
        if (args?.cardIndex > -1) {
            newEvents.splice(args.cardIndex, 1)
            setFetesData(newEvents)
        }
    }

    return (
        <React.Fragment>
            <div className={`flex gap-x-8 overflow-x-auto on-hover-show-scrollbar w-[calc(100vw_-_132px)] pb-7 custom-cursor-pointer ${events?.length > 0 && "min-h-[370px]"}`}>
                {/* cards */}
                {
                    // events && events.length > 0 ? events.map((event: any, index: number) => (
                    //     <FeteCard key={index} event={event} type={type} afterDelete={afterDelete} cardIndex={index} />
                    // ))
                    fetesData && fetesData.length > 0 ? fetesData.map((event: any, index: number) => (
                        <FeteCard key={index} event={event} type={type} afterDelete={afterDelete} cardIndex={index} />
                    ))
                        : (
                            <>
                                {type === "upcoming" &&
                                    <div className="w-full flex justify-center">
                                        <div className="mr-[30px]">
                                            <img className="mb-3" src={allImgPaths.upcoingFeteEmptyState} alt="" />
                                            <p className="font-interSemiBold text-base text-[#344054] pb-1.5 text-center">No upcoming fete!</p>
                                            <p className="text-base font-normal text-[#344054] mb-4 text-center">Get started now!</p>
                                            <button className="submit-btn-blue !px-5 !py-2 whitespace-nowrap !bg-white border !border-[#A59DFB] !text-[#1e0af5] flex gap-x-1.5 items-center mx-auto hover:!bg-[#E8E6FE]" onClick={handleNewFeteClick}>
                                                <img src={allImgPaths.plusIcon7} alt="" /> New Fete
                                            </button>
                                        </div>
                                    </div>
                                }

                                {
                                    type === "past" &&
                                    <div className="w-full flex justify-center">
                                        <div className="">
                                            <img className="mb-3 ml-auto mr-auto" src={allImgPaths.pastFeteEmptyState} alt="" />
                                            <p className="font-interSemiBold text-base text-[#344054] pb-1.5 text-center">Looks like last few months have been dull!</p>
                                            <p className="text-base font-normal text-[#344054] mb-4 text-center">No fetes detected</p>
                                        </div>
                                    </div>
                                }
                            </>
                        )}
            </div>

        </React.Fragment>
    )
}

export default FeteList;